import { questionType } from "src/app/modules/settings/settings.interface";
import { SettingsService } from "../services/settings.service";
import { IUserData } from "./interfaces";
import { PaymentProdauctType, PaymentProductKind, ServiceType, productNames, usage, SeoType } from "./types";
import { HttpService } from 'src/app/core/services/http.service';


export function getDocumentHeight() {
    var body = document.body,
        html = document.documentElement;

    var height = Math.max(body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight);
    return height;
}

/************************************************* */
export function hashCode(value: string): string {
    let hash = 0, i, chr;
    for (i = 0; i < value.length; i++) {
        chr = value.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return String(hash);
}
/************************************************* */
export function convertBytesToHumanly(bytes: number, units = ['Bytes', 'KB', 'MB', 'GB', 'TB']) {
    let size = bytes.toString();
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < units.length; i++) {
        if (bytes < 1000) { return size + ' ' + units[i]; }
        bytes /= 1000;
        size = bytes.toFixed(1);
    }
    return size + ' ' + units[units.length - 1];
}
/************************************************* */
export function generateId(prefix?: string): string {
    return Math.random().toString().split('.')[1] + '_' + new Date().getTime() + '_' + (prefix ? prefix : 'id');
}
/************************************************* */
export function log(...data: any[]): void {
    if (!SettingsService['ENABLE_DEBUG_LOGS']) { return; }
}
/************************************************* */
export function warning(...data: any[]): void {
    if (!SettingsService['ENABLE_DEBUG_LOGS']) {
        if (data && data.length > 0) {
            console.warn('warning', data[0]);
        }
    } else {
        console.warn(...data);
    }
}
/************************************************* */
export function appendObjects(main: { [key: string]: any }, second: { [key: string]: any }): { [key: string]: any } {
    // =>check if main object is undefined
    if (!main) { main = {}; }
    // =>check if second is undefined
    if (second) {
        // =>iterate on second object
        for (const key in second) {
            if (Object.prototype.hasOwnProperty.call(second, key)) {
                const element = second[key];
                // =>append to main object
                main[key] = element;
            }
        }
    }
    // =>return main object
    return main;
}
/************************************************* */
export function replaceByRegex(text: string, values: object, regex: RegExp = /:\w+/g) {
    // =>if must replace values in translate text
    if (text && values) {
        // =>get all variables of text
        const matches = text.match(regex);
        // =>replace all variables
        if (Array.isArray(matches)) {
            for (const match of matches) {
                if (values[match.substr(1)] !== undefined) {
                    text = text.replace(match, values[match.substr(1)]);
                }
            }
        }
    }
    return text
}
/************************************************* */
/**
 * get a username or name of user and return two or one char of name as avatar of user
 * @param name string
 */
export function getAvatarName(name: string) {
    // =>if name len is less than 3 char
    if (!name || name.length < 3) { return name; }
    // =>split name by space and if more than one section
    const sp = name.trim().split(' ');
    if (sp.length > 1 && sp[0].length > 0 && sp[1].length > 0) {
        return sp[0][0] + sp[1][0];
    }
    // =>return two first chars of name
    return name.substr(0, 2);
}
/************************************************* */
export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
/************************************************* */
export function addCurrency(price: number, currency?: string) {
    let Currency = currency ? currency : 'ریال';
    return numberWithCommas(price) + Currency;
}
/************************************************* */
export function colorIsLight(color: string) {
    color = color.substring(1);      // strip #
    const rgb = parseInt(color, 16);   // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff;  // extract red
    const g = (rgb >> 8) & 0xff;  // extract green
    const b = (rgb >> 0) & 0xff;  // extract blue

    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness >= 128;
}

/************************************************* */
export function convertVersionNumberToString(version: number) {
    let major = Math.floor(version / 1000);
    version %= 1000;
    let minor = Math.floor(version / 100);
    version %= 100;
    let patch = version;

    return major + '.' + minor + '.' + patch;
}
/************************************************* */
export function convertEnumToArray(enumObject, type: 'name' | 'value' = 'value') {
    const StringIsNumber = value => isNaN(Number(value)) === false;
    if (type === 'name') {
        return Object.keys(enumObject)
            .filter(StringIsNumber)
            .map(key => enumObject[key]);
    } else {
        return Object.keys(enumObject)
            .filter(value => isNaN(Number(value)))
            .map(key => enumObject[key]);

    }
}
/************************************************* */
export function randomColor() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
}
/************************************************* */
export function convertSecondsToHumanly(seconds: number) {
    let units = ['s', 'm', 'h', 'd', 'w'];
    let i = 0;
    // tslint:disable-next-line: prefer-for-of
    while (true) {
        if (units[i] === 's' || units[i] === 'm') {
            if (seconds < 60) break;
            seconds /= 60;
            i++;
        }
        else if (units[i] === 'h') {
            if (seconds < 24) break;
            seconds /= 24;
            i++;
        } else if (units[i] === 'd') {
            if (seconds < 7) break;
            seconds /= 7;
            i++;
        } else {
            break;
        }
        seconds = Number(seconds.toFixed(1));
        if (i >= units.length) break;
    }
    return { unit: units[i], time: seconds };
}
/************************************************* */
export function lengthInUtf8Bytes(str: string) {
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    var m = encodeURIComponent(str).match(/%[89ABab]/g);
    return str.length + (m ? m.length : 0);
}
/************************************************* */
export function generateString(length = 10, includeNumbers = true, includeChars = true) {
    var result = '';
    var characters = '';
    if (includeChars) {
        characters += 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    }
    if (includeNumbers) {
        characters += '0123456789';
    }
    if (!includeChars && !includeNumbers) {
        characters += '-';
    }
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const ComponentLookupRegistry: Map<string, any> = new Map();

export const ComponentLookup = (key: string): any => {
    return (cls) => {
        ComponentLookupRegistry.set(key, cls);
    };
};

/************************************************* */
export function questionBankType(questiontype: questionType) {
    if (questiontype === 'text') {
        return 'متنی'
    } else if (questiontype === 'boolean') {
        return 'بله یا خیر'
    } else if (questiontype === 'single_select') {
        return 'تک گزینه ای'
    } else if (questiontype === 'file') {
        return 'فایل'
    } else if (questiontype === 'multi_select') {
        return 'چند گزینه ای'
    } else {
        return questiontype
    }
}

export function setUserName(obj: IUserData, dt?: string) {
    let name: string = '';
    if (obj.company_name) {
        name = obj.company_name;
    } else if (obj.first_name && obj.last_name) {
        name = obj.first_name + ' ' + obj.last_name;
    } else if (obj.first_name && !obj.last_name) {
        name = obj.first_name
    } else if (!obj.first_name && !obj.last_name) {
        if (dt) {
            name = dt;
        } else {
            name = obj.phone;
        }
    }
    return name;
}
export function isEmpty(value: any): boolean {
    const reg = /^\s+$/;
    if (
        (!value ||
            value === '' ||
            reg.test(value) ||
            (Array.isArray(value) && value.length === 0)) &&
        value !== 0 &&
        value !== false
    ) {
        return true;
    } else {
        return false;
    }
}
export function isValidPhoneNumber(phoneNumber: string) {
    if (!isEmpty(phoneNumber)) {
        if (!/^09\d{1}\d{8}$/.test(phoneNumber)) {
            return false;
        }
        return true;
    }
    return false;
}
export function cutString(str: string, cut?: number) {
    if (!cut) cut = 120
    if (str != undefined) {
        if (str.length > cut) {
            return str.substring(0, cut) + '...';
        }
        else {
            return str;
        }
    } else {
        return str;
    }
};

export function serviceTypes(type: ServiceType): string {
    switch (type) {
        case 'petition':
            return 'دادخواست'
        case 'course':
            return 'دوره آموزشی'
        case 'custom_contract':
            return 'سفارش قرارداد'
        case 'ready_contract':
            return 'قرارداد آماده'
        case 'smart_contract':
            return 'قرارداد هوشمند'
        case 'article':
            return 'تازه های حقوقی'
        case 'custom_complaint':
            return 'سفارش شکوائیه '
        case 'ready_complaint':
            return 'شکوائیه آماده'
        case 'custom_petition':
            return 'سفارش دادخواست'
        case 'ready_petition':
            return 'دادخواست آماده'
        default:
            return 'نامشخص!'
    }
};

export function paymentTranlation(type: usage): string {
    switch (type) {
        case 'contract_expertise':
            return 'کارشناسی قرارداد'
        case 'contract_meeting':
            return 'حضور در جلسه قرارداد'
        case 'face_to_face_consultation':
            return 'مشاوره حضوری'
        case 'offline_consultation':
            return 'مشاوره آفلاین'
        case 'online_consultation':
            return 'مشاوره آنلاین'
        case 'learning':
            return 'آموزش'
        case 'petition':
            return 'دادخواست هوشمند'
        case 'custom_petition':
            return 'سفارش دادخواست '
        case 'ready_petition':
            return 'دادخواست آماده'
        case 'custom_contract':
            return 'سفارش قرارداد '
        case 'ready_contract':
            return 'قرارداد آماده'
        case 'smart_contract':
            return 'قرارداد هوشمند'
        case 'lawyer':
            return 'وکیل'
        case 'ready_complaint':
            return 'شکوائیه آماده'
        case 'custom_complaint':
            return 'سفارش شکوائیه'
        case 'smart_complaint':
            return 'شکوائیه هوشمند'
        case 'declaration':
            return 'تنظیم یا کارشناسی اظهارنامه'
        case 'bill':
            return 'تنظیم یا کارشناسی لایحه'
        case 'course':
            return 'آموزش'
        case 'other_judicial_request':
            return 'سایر درخواست‌ها'
        default:
            return 'همه موارد'
       
    }
}
/************************************************* */


export function seoTranlation(type: SeoType): string {
    switch (type) {
        case 'petition':
            return 'دادخواست ها'
        case 'course':
            return 'آموزش ها'
        case 'search':
            return 'صفحات دسته بندی'
        case 'contract':
            return 'قرارداد ها'
        case 'complaint':
            return 'شکوائیه ها'
        case 'article':
            return 'مجلات'
        case 'static':
            return 'صفحات عمومی'
        default:
            return 'نامشخص!'
    }
};

/************************************************* */
export function PaymnetProduct(type: PaymentProdauctType, product?: PaymentProductKind) {
    switch (type) {
        case 'charge_wallet':
            return 'شارژ کیف پول'
        case 'refund':
            return 'بازگشت به کیف پول'
        case 'purchase_products':
            switch (product) {
                case 'contract_expertise':
                    return 'درخواست کارشناسی قرارداد'
                case 'contract_meeting':
                    return 'درخواست حضور در جلسه قرارداد'
                case 'custom_contract':
                    return 'سفارش قرارداد'
                case 'ready_contract':
                    return 'خرید قرارداد آماده'
                case 'smart_contract':
                    return 'خرید قرارداد هوشمند'
                case 'extra_question':
                    return 'خرید سوالات اضافه'
                case 'face_to_face_consultation':
                    return 'خرید مشاوره حضوری'
                case 'offline_consultation':
                    return 'خرید مشاوره آفلاین'
                case 'online_consultation':
                    return 'خرید مشاوره آنلاین'
                case 'learning':
                    return 'خرید آموزش'
                case 'petition':
                    return 'خرید دادخواست هوشمند'
                case 'ready_petition':
                    return 'خرید دادخواست آماده'
                case 'custom_petition':
                    return 'سفارش دادخواست '
                case 'ready_complaint':
                    return 'خرید شکوائیه آماده'
                case 'custom_complaint':
                    return 'سفارش شکوائیه '
                case 'voip':
                    return 'خرید مشاوره تلفنی'
                case 'bill':
                    return 'درخواست لایحه'
                case 'declaration':
                    return 'درخواست اظهارنامه'
                case 'other_judicial_request':
                    return 'خرید سایر درخواست ها'
                case 'package':
                    return 'خرید بسته حقوقی'
                default:
                    return 'خرید محصول'
            }
    }
    // let paymentType: string = '';
    // if (type == 'purchase_products') {
    //     if (product == 'contract_expertise') {
    //         paymentType = 'درخواست کارشناس قرارداد'
    //     }
    //     else if (product == 'contract_meeting') {
    //         paymentType = 'درخواست حضور در جلسه قرارداد'
    //     }
    //     else if (product == 'custom_contract') {
    //         paymentType = 'خرید قرارداد سفارشی'
    //     }
    //     else if (product == 'extra_question') {
    //         paymentType = 'سوالات اضافه'
    //     }
    //     else if (product == 'face_to_face_consultation') {
    //         paymentType = 'خرید مشاوره حضوری'
    //     }
    //     else if (product == 'learning') {
    //         paymentType = 'خرید آموزش'
    //     }
    //     else if (product == 'offline_consultation') {
    //         paymentType = 'خرید مشاوره آفلاین'
    //     }
    //     else if (product == 'online_consultation') {
    //         paymentType = 'خرید مشاوره آنلاین'
    //     }
    //     else if (product == 'petition') {
    //         paymentType = 'خرید دادخواست'
    //     }
    //     else if (product == 'ready_contract') {
    //         paymentType = 'خرید قرارداد آماده'
    //     }
    //     else if (product == 'smart_contract') {
    //         paymentType = 'خرید قرارداد هوشمند'
    //     }
    //     else if (product == 'voip') {
    //         paymentType = 'خرید مشاوره تلفنی'
    //     }
    //     else if (product == 'ready_petition') {
    //         paymentType = 'خرید دادخواست آماده'
    //     }
    //     else if (product == 'custom_petition') {
    //         paymentType = 'خرید دادخواست سفارشی'
    //     }
    // }
    // else if (type == 'charge_wallet') {
    //     paymentType = 'شارژ کیف پول'
    // }
    // else if (type == 'refund') {
    //     paymentType = 'بازگشت به کیف پول';
    // }
    // return paymentType;
}

export function statusTranslate(statusval: string) {
    let statusTrs = new Map<string, {
        value: string,
        status: string
    }>()
    statusTrs.set('set_answer',{
        value: 'در انتظار پاسخ',
        status: 'warning'
    })
    statusTrs.set('successful_payment', {
        value: 'پرداخت شده',
        status: 'success'   
    })
    statusTrs.set('payment', {
        value: 'در انتظار پرداخت',
        status: 'warning'  
    })
    statusTrs.set('set_lawyer', {
        value: 'در انتظار انتخاب کارشناس',
        status: 'warning'  
    })
    statusTrs.set('set_file', {
        value: 'در انتظار ثبت فایل توسط کارشناس',
        status: 'warning'  
    })
    statusTrs.set('set_info', {
        value: 'در  انتظار ثبت مشخصات',
        status: 'warning'  
    })
    statusTrs.set('cancel', {
        value: 'لغو شده',
        status: 'danger'  
    })
    statusTrs.set('canceled', {
        value: 'لغو شده',
        status: 'danger'  
    })
    statusTrs.set('complete', {
        value: 'پایان یافته',
        status: 'success'  
    })
    statusTrs.set('preview', {
        value: 'پایان یافته',
        status: 'success'
    })
    statusTrs.set('repeat', {
        value: 'تکرار درخواست',
        status: 'info'  
    })
    statusTrs.set('in_process', {
        value: 'در حال پردازش',
        status: 'warning'  
    })
    statusTrs.set('finish', {
        value: 'ثبت نهایی',
        status: 'success'  
    })
    return statusTrs.get(statusval)
}


/************************************************* */
export function urlJoin(url1: string, url2: string) {
    if (url1 && url1.endsWith('/')) url1 = url1.substring(0, url1.length - 1);
    if (url2 && url2.startsWith('/')) url1 = url1.substring(1);

    return url1 + '/' + url2;
}
/************************************************* */
export function getProductListResponse(productName: productNames | productNames[], search: string, http: HttpService) {
    if (Array.isArray(productName)) {
        productName = productName[0];
    }
    let method: 'GET' | 'POST' = 'POST';
    let path: string = '';
    let param: any = {};
    switch (productName) {
        case 'petition':
            method = 'POST';
            path = 'petition/petition-list/';
            param = { page_size: 10, search_param: search }
            break;
        case 'learning':
            method = 'POST';
            path = 'learning/search/';
            param = {
                is_active: true,
                page_size: 10,
                title: search,
            }
            break;
        case 'ready_contract':
            method = 'POST';
            path = 'contract/ready-contract/list/';
            param = { page_size: 10, search: search };
            break;

        case 'smart_contract':
            method = 'POST';
            path = 'contract/smart-contract/list/';
            param = { page_size: 10, search: search };
            break;
        case 'custom_contract':
            method = 'POST';
            path = 'contract/custom-contract/list/';
            param = { page_size: 10, search: search }
            break;
        default:
            return false;
    }
    return http.getSuccessResult({
        method: method,
        path: path,
        body: param
    })
}

/************************************************* */
// convert persian and arabic number to english number

export function persianToEnglish(s) {
  return s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
}

export function arabicToEnglish(s) {
  return s.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
}

export function convertToValidNumber(value) {
  if (/[۰-۹]/.test(String(value))) {
    return persianToEnglish(value)
  } else if (/[٠-٩]/.test(String(value))) {
    return arabicToEnglish(value)
  }
  return value;
}

export function formatDurationInPersian(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const faHours = hours > 0 ? `${convertToValidNumber(hours)} ساعت` : '';
  const faMinutes = minutes > 0 ? `${convertToValidNumber(minutes)} دقیقه` : '';

  return [faHours, faMinutes].filter(Boolean).join(' و ');
}

export function scroll(elementRefrnce: string) {
  const container = document.querySelector('.scrollable-container');
  const element = document.querySelector(elementRefrnce);
  const headerOffset = (document.querySelector('.navbar') as HTMLElement).offsetHeight;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + container.scrollTop - headerOffset - 20;

  container.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
  }